module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    微信开放平台管理\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-alert', {
    attrs: {
      "title": "开通微信开放平台管理并且绑定小程序/公众号",
      "type": "warning",
      "description": "为用户的公众号开通开放平台账号并且绑定小程序/公众号，用于打通用户的小程序和公众号用户和卡券等数据。如果未授权，\n  请手动开通微信开放平台并且绑定。",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("如果手动绑定绑定后一定要执行【微信-> 粉丝管理-> 同步微信粉丝】操作，不然会导致小程序用户和微信公众号用不能打通")]), _vm._v(" "), _c('el-form', {
    ref: "form"
  }, [_c('el-form-item', {
    attrs: {
      "label": "小程序卡券打通微信文档"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/cgi-bin/announce?action=getannouncement&key=1490190158&version=1&lang=zh_CN&platform=2",
      "target": "_blank"
    }
  }, [_vm._v("点击查看")])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("开通微信开放平台绑定小程序")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f919d68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f919d68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/brand/wechat/open.vue
// module id = 2658
// module chunks = 0